module.exports = __webpack_public_path__ + "img/google_play.4029fa85.svg";